import { Core } from "@faire/design-tokens";
import { Opacity } from "@faire/web--source/slate/Color";
import { Family } from "@faire/web--source/slate/Font";
import { Row } from "@faire/web--source/slate/Layout";
import { responsiveMediaQueries } from "@faire/web--source/slate/Theme/responsiveMediaQueries";
import { TypographyStyles } from "@faire/web--source/slate/Typography";
import ClickOutside from "@faire/web--source/ui/ClickOutside";
import styled, { css } from "styled-components";
export var CancelButton = styled.button.withConfig({
    componentId: "sc-a4e4fbe6-0"
})([
    "",
    " margin:0;background:none;padding:4px 8px 4px 1px;border:0;cursor:pointer;outline:0;",
    "{padding:4px 16px 4px 1px;}"
], TypographyStyles({
    as: undefined
}), responsiveMediaQueries.mobile);
export var TopSearchWrapper = styled(ClickOutside).withConfig({
    componentId: "sc-a4e4fbe6-1"
})([
    "font-family:",
    ";display:flex;flex-direction:row;align-items:center;background:white;",
    "{",
    "}"
], Family.sansSerif, responsiveMediaQueries.tablet, function(props) {
    return props.$tabletFullWidth ? css([
        "flex:1;"
    ]) : css([
        "width:400px;"
    ]);
});
export var TopSearchComponent = styled(Row).attrs({
    justify: "space-between"
}).withConfig({
    componentId: "sc-a4e4fbe6-2"
})([
    "height:40px;border-radius:100px;border:1px solid ",
    ";background-color:",
    ";transition:border 120ms ease-out;&.expanded{border:1px solid ",
    ";background-color:",
    ";}width:100%;font-family:",
    ";",
    "{",
    "}"
], Core.border.subdued, Core.surface.subdued + Opacity.O_60, Core.border.subdued, Core.surface.inverse, Family.sansSerif, responsiveMediaQueries.mobile, function(props) {
    return props.$isSearchVisible ? css([
        "margin:12px 8px 12px 16px;"
    ]) : css([
        "margin:12px 16px 12px 16px;"
    ]);
});
export var IconWrapper = styled(Row).attrs({
    align: "center"
}).withConfig({
    componentId: "sc-a4e4fbe6-3"
})([
    "padding:",
    ";background:none;border:0;cursor:pointer;outline:0;"
], function(props) {
    return props.$padding;
});
